var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n\t"+_vm._s(_vm.tradable.qty.mt)+",\n\t"+_vm._s(_vm.tradable.qty.partial_ok
			? _vm.__("Partial quantity possible")
			: _vm.__("Partial quantity not desired"))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }